import { Container } from "@mui/material";

const Hr = () => {
  return (
    <Container
      maxWidth="xxl"
      style={{
        backgroundImage: "url(https://i.ibb.co/JwHMKBkN/Shape-11-copy-6.webp)", // Replace with your image URL
        height: "8px", // Adjust the height as needed
      }}
    ></Container>
  );
};
export default Hr;
